import React from "react";

export const KenoHitGem = () => (
  <svg className="keno-hit-gem" viewBox="0 0 100 100" aria-hidden="true">
    <path d="M25 5H75L96 28V73L75 95H25L4 73V28Z" fill="var(--keno-gem-base, #5ee542)" />
    <path d="M25 5L32 24H68L75 5ZM4 28L24 33V67L4 73Z" fill="var(--keno-gem-light, #abff88)" />
    <path d="M75 5L68 24L77 33L96 28ZM96 28L77 33V67L96 73Z" fill="var(--keno-gem-right, #44bc30)" />
    <path d="M4 73L24 67L32 76L25 95ZM25 95L32 76H68L75 95Z" fill="var(--keno-gem-bottom, #369728)" />
    <path d="M75 95L68 76L77 67L96 73Z" fill="var(--keno-gem-dark, #237c1c)" />
    <path d="M32 24H68L77 33V67L68 76H32L24 67V33Z" fill="var(--keno-gem-center, #55d63a)" />
    <path d="M25 5H75L96 28V73L75 95H25L4 73V28Z" fill="none" stroke="var(--keno-gem-stroke, #c3ffa8)" strokeWidth="2" opacity=".6" />
  </svg>
);